module.exports = __webpack_public_path__ + "static/media/palais.17038b5a.svg";